import { render, staticRenderFns } from "./AddVouchers.vue?vue&type=template&id=65047391"
import script from "./AddVouchers.vue?vue&type=script&lang=js"
export * from "./AddVouchers.vue?vue&type=script&lang=js"
import style0 from "./AddVouchers.vue?vue&type=style&index=0&id=65047391&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports